;(function ($) {
	'use strict';

	$(document).ready(function() {
		responsive_oembed_wrapping();
	});

	function responsive_oembed_wrapping() {
		// Find all iframe elements with src containing "YouTube.com," "youtu.be," or "vimeo.com"
		const videoIframes = document.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"], iframe[src*="vimeo.com"]');

		// Loop through each found iframe and wrap them in a div
		videoIframes.forEach((iframe) => {
			// Create a div element
			const wrapperDiv = document.createElement('div');

			// Add a class to the div
			wrapperDiv.classList.add('embed', 'embed--16by9');

			// Replace the iframe with the div
			iframe.parentNode.replaceChild(wrapperDiv, iframe);

			// Append the iframe to the div
			wrapperDiv.appendChild(iframe);
		});
	}
})(jQuery);
